import { Box, styled } from '@mui/material'

export const StyledGroup = styled(Box)(({ theme, border, borderRadius }) => ({
  display: 'inline-flex',
  border: border || 'none',
  borderRadius: borderRadius || theme.spacing(0.75),
  height: '100%',
  overflow: 'hidden',
  ' > *:first-of-type': {
    overflow: 'hidden',
    borderRadius: '5px 0 0 5px'
  },
  ' > *:last-child': {
    overflow: 'hidden',
    borderRadius: '0 5px 5px 0'
  }
}))

export const StyledButton = styled(Box)(({ theme, iconsize, iconcolor }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
  fontSize: iconsize || '15px',
  minWidth: theme.spacing(4),
  minHeight: theme.spacing(2.75),
  color: iconcolor || theme.palette.grey['600'],
  transition: 'all ease-in-out .2s',
  '&:hover': {
    cursor: 'pointer',
    color: theme.palette.primary.main
  }
}))

export const StyledTextButton = styled(StyledButton)(({ theme }) => ({
  fontSize: 12,
  padding: theme.spacing(0, 1.5, 0, 1.25),
  whiteSpace: 'nowrap'
}))
